// Personal list for a wide range of colours and their shades.
// All colours - https://prnt.sc/vwdiuy - less resolution that individual ones

// Available colours: blue, indigo, purple, pink, red, orange, yellow, green, teal, cyan, gray
// Shades available for each colour: 100-900 - 100 = lightest, 200 = darkest

// How to access a colour: {colourname}.s{shade} for example - blue.s700, red.s200, etc...

// Each colour shade has a recommended text colour if your writing text on top of that colour.
// To access text colour for each shade: {colourname}.txt.s{shade} for example - blue.txt.s800, etc ...

// Base - white & black
export const base = {
  white: "#fff",
  black: "#000",
};

// Blue - https://prnt.sc/vwdhdk
export const blue = {
  s100: "#cfe2ff",
  s200: "#9ec5fe",
  s300: "#6ea8fe",
  s400: "#3d8bfd",
  s500: "#0d6efd",
  s600: "#0a58ca",
  s700: "#084298",
  s800: "#052c65",
  s900: "#031633",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#fff",
    s600: "#fff",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Indigo - https://prnt.sc/vwdh95
export const indigo = {
  s100: "#e0cffc",
  s200: "#c29ffa",
  s300: "#a370f7",
  s400: "#8540f5",
  s500: "#6610f2",
  s600: "#520dc2",
  s700: "#3d0a91",
  s800: "#290661",
  s900: "#140330",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#fff",
    s500: "#fff",
    s600: "#fff",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Purple - https://prnt.sc/vwdh4c
export const purple = {
  s100: "#e2d9f3",
  s200: "#c5b3e6",
  s300: "#a98eda",
  s400: "#8c68cd",
  s500: "#6f42c1",
  s600: "#59359a",
  s700: "#432874",
  s800: "#2c1a4d",
  s900: "#160d27",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#fff",
    s600: "#fff",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Pink - https://prnt.sc/vwdgq0
export const pink = {
  s100: "#f7d6e6",
  s200: "#efadce",
  s300: "#e685b5",
  s400: "#de5c9d",
  s500: "#d63384",
  s600: "#ab296a",
  s700: "#801f4f",
  s800: "#561435",
  s900: "#2b0a1a",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#fff",
    s600: "#fff",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Red - https://prnt.sc/vwdgl7
export const red = {
  s100: "#f8d7da",
  s200: "#f1aeb5",
  s300: "#ea868f",
  s400: "#e35d6a",
  s500: "#dc3545",
  s600: "#b02a37",
  s700: "#842029",
  s800: "#58151c",
  s900: "#2c0b0e",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#fff",
    s600: "#fff",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Orange - https://prnt.sc/vwdga5
export const orange = {
  s100: "#ffe5d0",
  s200: "#fecba1",
  s300: "#feb272",
  s400: "#fd9843",
  s500: "#fd7e14",
  s600: "#ca6510",
  s700: "#984c0c",
  s800: "#653208",
  s900: "#331904",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#000",
    s600: "#000",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Yellow - https://prnt.sc/vwdg5n
export const yellow = {
  s100: "#fff3cd",
  s200: "#ffe69c",
  s300: "#ffda6a",
  s400: "#ffcd39",
  s500: "#ffc107",
  s600: "#cc9a06",
  s700: "#997404",
  s800: "#664d03",
  s900: "#332701",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#000",
    s600: "#000",
    s700: "#000",
    s800: "#fff",
    s900: "#fff",
  },
};

// Green - https://prnt.sc/vwdg0s
export const green = {
  s100: "#d1e7dd",
  s200: "#a3cfbb",
  s300: "#75b798",
  s400: "#479f76",
  s500: "#198754",
  s600: "#146c43",
  s700: "#0f5132",
  s800: "#0a3622",
  s900: "#051b11",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#fff",
    s600: "#fff",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Teal - https://prnt.sc/vwdfsu
export const teal = {
  s100: "#d2f4ea",
  s200: "#a6e9d5",
  s300: "#79dfc1",
  s400: "#4dd4ac",
  s500: "#20c997",
  s600: "#1aa179",
  s700: "#13795b",
  s800: "#0d503c",
  s900: "#06281e",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#000",
    s600: "#000",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Cyan - https://prnt.sc/vwdfm2
export const cyan = {
  s100: "#cff4fc",
  s200: "#9eeaf9",
  s300: "#6edff6",
  s400: "#3dd5f3",
  s500: "#0dcaf0",
  s600: "#0aa2c0",
  s700: "#087990",
  s800: "#055160",
  s900: "#032830",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#000",
    s600: "#000",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// Gray - https://prnt.sc/vwdf77
export const gray = {
  s100: "#f8f9fa",
  s200: "#e9ecef",
  s300: "#dee2e6",
  s400: "#ced4da",
  s500: "#adb5bd",
  s600: "#6c757d",
  s700: "#495057",
  s800: "#343a40",
  s900: "#212529",
  txt: {
    s100: "#000",
    s200: "#000",
    s300: "#000",
    s400: "#000",
    s500: "#000",
    s600: "#fff",
    s700: "#fff",
    s800: "#fff",
    s900: "#fff",
  },
};

// All colours imports array - doesn't include base
export const colours_array = [blue, indigo, purple, pink, red, orange, yellow, green, teal, cyan, gray];
